import { inject, Injectable } from "@angular/core";
import { ApiBaseService } from "@app/core/services/api-base.service";
import { Observable } from "rxjs";
import { TeamInfo } from "../models/team.model";

@Injectable({
    providedIn: 'root'
})
export class ControlMeasureHeaderApiService {

    readonly #API_PATH_CONTROL_MEASURE: string = 'controlmeasure'
    readonly #apiBaseService = inject( ApiBaseService)

    getTeam(teamId): Observable<TeamInfo> {

        const payload = {
            teamId
        }

        return this.#apiBaseService.observablePost(`${this.#API_PATH_CONTROL_MEASURE}/Fetch_Team`, payload);
    }

    setStatusControlMeasure(salesBasketId: string, basketTransId: string = '', controlMeasureStatus: number = 0, confirmOwnControlMeasure: boolean = false): Observable<any> {

        const payload = {
            salesBasketId,
            basketTransId,
            controlMeasureStatus,
            confirmOwnControlMeasure
        }

        return this.#apiBaseService.observablePost<any>(`${this.#API_PATH_CONTROL_MEASURE}/Do_SetControlMeasureStatus`, payload)
    }

    deleteControlMeasureValue(salesBasketId: string, basketTransId: string = ''): Observable<any> {
        const payload = {
            salesBasketId,
            basketTransId,
            pbaVarNoRel: '',
            dataAreaId_PbaVarNoRel: ''
        }

        return this.#apiBaseService.observablePost<any>(`${this.#API_PATH_CONTROL_MEASURE}/Do_DeleteControlMeasureValue`, payload)
    }

    saveControlMeasureValue(
        salesBasketId: string,
        basketTransId: string = '',
        pbaVarNoRel: string = '',
        dataAreaId_PbaVarNoRel: string = '',
        value: string = '',
        displayValue: string = '',
        valueOriginal: string = '',
        displayValueOriginal: string = '',
        label_PbaVarNoRel: string = '',
        infoText: string = ''
    ): Observable<any> {
        const payload = {
            salesBasketId,
            basketTransId,
            pbaVarNoRel,
            dataAreaId_PbaVarNoRel,
            value,
            displayValue,
            valueOriginal,
            displayValueOriginal,
            label_PbaVarNoRel,
            infoText
        }

        return this.#apiBaseService.observablePost<any>(`${this.#API_PATH_CONTROL_MEASURE}/Do_SaveControlMeasureValue`, payload)
    }

    saveControlMeasureValueState(salesBasketId: string, basketTransId: string = '', pbaVarNoRel: string = '', dataAreaId_PbaVarNoRel: string = '', valueState: number = 0): Observable<any> {
        const payload = {
            salesBasketId,
            basketTransId,
            pbaVarNoRel,
            dataAreaId_PbaVarNoRel,
            valueState
        }

        return this.#apiBaseService.observablePost<any>(`${this.#API_PATH_CONTROL_MEASURE}/Do_SaveControlMeasureValueState`, payload)
    }

    deleteControlMeasureData(salesBasketId: string, basketTransId: string = '', pbaVarNoRel: string = '', dataAreaId_PbaVarNoRel: string = ''): Observable<any> {
        const payload = {
            salesBasketId,
            basketTransId,
            pbaVarNoRel,
            dataAreaId_PbaVarNoRel
        }

        return this.#apiBaseService.observablePost<any>(`${this.#API_PATH_CONTROL_MEASURE}/Do_DeleteControlMeasureValue`, payload)
    }
}
